import {
  getInt32,
  getObject,
} from "@surya-digital/leo-ts-types";
import { ProjectSortOrder } from "./projectSortOrder";


export namespace GetProjectBOUsersSortOrderEnums {
  /* eslint-disable @typescript-eslint/no-shadow */
  export namespace ColumnName {
    export enum ColumnName {
      NAME = "NAME",
      EMAIL_ADDRESS = "EMAIL_ADDRESS",
      ADDED_ON = "ADDED_ON",
    }
  
    export interface ColumnNameDTO {
      case: string;
    }
  
    export const fromDTO = (dto: ColumnNameDTO): ColumnName => {
      if (dto === undefined || dto === null) {
        throw new InvalidGetProjectBOUsersSortOrderColumnNameError(
          `Invalid DTO ${dto} provided for ColumnName.ColumnName`
        );
      }
      switch (dto.case) {
        case "NAME":
          return ColumnName.NAME;
        case "EMAIL_ADDRESS":
          return ColumnName.EMAIL_ADDRESS;
        case "ADDED_ON":
          return ColumnName.ADDED_ON;
        default:
          throw new InvalidGetProjectBOUsersSortOrderColumnNameError(
            `Case ${dto.case} is not valid case of ColumnName.ColumnName`
          );
      }
    };
  
    export const toDTO = (columnName: ColumnName): ColumnNameDTO => {
      const enumDTO = {
        case: ColumnName[columnName],
      };
      return enumDTO;
    };
  }
  
}
export interface GetProjectBOUsersSortOrderDTO {
  sortIndex: number;
  columnName: GetProjectBOUsersSortOrderEnums.ColumnName.ColumnNameDTO;
  order: ProjectSortOrder.ProjectSortOrderDTO;
}

export class GetProjectBOUsersSortOrder {
  readonly isGetProjectBOUsersSortOrderGetProjectBOUsersSortOrder: boolean = true;

  readonly sortIndex: number;
  readonly columnName: GetProjectBOUsersSortOrderEnums.ColumnName.ColumnName;
  readonly order: ProjectSortOrder.ProjectSortOrder;


  constructor(
  sortIndex: number, 
  columnName: GetProjectBOUsersSortOrderEnums.ColumnName.ColumnName, 
  order: ProjectSortOrder.ProjectSortOrder
  ) {
    this.sortIndex = sortIndex;
    this.columnName = columnName;
    this.order = order;
  }

  static fromDTO(dto: GetProjectBOUsersSortOrderDTO): GetProjectBOUsersSortOrder {
    const sortIndex = getInt32(dto, "sortIndex", InvalidGetProjectBOUsersSortOrderSortIndexError);
    const columnName = GetProjectBOUsersSortOrderEnums.ColumnName.fromDTO(getObject(dto, "columnName", InvalidGetProjectBOUsersSortOrderColumnNameError));
    const order = ProjectSortOrder.fromDTO(getObject(dto, "order", InvalidGetProjectBOUsersSortOrderOrderError));
    return new GetProjectBOUsersSortOrder(
      sortIndex,
      columnName,
      order
    );
  }

  toDTO(): GetProjectBOUsersSortOrderDTO {
    const dto: GetProjectBOUsersSortOrderDTO = {
        sortIndex: this.sortIndex,
        columnName: GetProjectBOUsersSortOrderEnums.ColumnName.toDTO(this.columnName),
        order: ProjectSortOrder.toDTO(this.order)
    };
    return dto;
  }
  }

GetProjectBOUsersSortOrder.prototype.toString = function toString(): string {
  return `GetProjectBOUsersSortOrder(sortIndex='${this.sortIndex}',columnName='${this.columnName}',order='${this.order}')`;
};

export class InvalidGetProjectBOUsersSortOrderError extends Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGetProjectBOUsersSortOrderError";
  }
}
export class InvalidGetProjectBOUsersSortOrderSortIndexError extends InvalidGetProjectBOUsersSortOrderError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGetProjectBOUsersSortOrderSortIndexError";
  }
}

export class InvalidGetProjectBOUsersSortOrderColumnNameError extends InvalidGetProjectBOUsersSortOrderError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGetProjectBOUsersSortOrderColumnNameError";
  }
}

export class InvalidGetProjectBOUsersSortOrderColumnNameNameError extends InvalidGetProjectBOUsersSortOrderColumnNameError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGetProjectBOUsersSortOrderColumnNameNameError";
  }
}

export class InvalidGetProjectBOUsersSortOrderColumnNameEmailAddressError extends InvalidGetProjectBOUsersSortOrderColumnNameError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGetProjectBOUsersSortOrderColumnNameEmailAddressError";
  }
}

export class InvalidGetProjectBOUsersSortOrderColumnNameAddedOnError extends InvalidGetProjectBOUsersSortOrderColumnNameError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGetProjectBOUsersSortOrderColumnNameAddedOnError";
  }
}

export class InvalidGetProjectBOUsersSortOrderOrderError extends InvalidGetProjectBOUsersSortOrderError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGetProjectBOUsersSortOrderOrderError";
  }
}
